import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { http } from "../lib/api";

export default function StaticPage() {
  const { slug } = useParams();
  const [page, setPage] = useState(null);
  useEffect(() => { http.get(`/pages/${slug}`).then((r) => setPage(r.data)).catch(() => setPage(false)); }, [slug]);

  if (page === false) return <div className="p-20 text-center text-zinc-500">Page not found.</div>;

  return (
    <div className="max-w-3xl mx-auto px-4 py-16">
      <h1 className="font-display text-5xl sm:text-7xl text-white uppercase tracking-tight mb-8">{page?.title}</h1>
      <div className="prose prose-invert text-zinc-300 leading-relaxed whitespace-pre-line">{page?.body}</div>
    </div>
  );
}
